import "./Tela02.styles.css";
import videoThumb from "../../img/imgsTela2/setup.png";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { useState, useEffect } from "react";


import finalista1 from "../../img/imgsTela2/pessoa1.jpeg";
import finalista2 from "../../img/imgsTela2/pessoa2.png";
import finalista3 from "../../img/imgsTela2/pessoa3.png";
import finalista4 from "../../img/imgsTela2/pessoa4.png";
import finalista5 from "../../img/imgsTela2/pessoa5.jpg";
import finalista6 from "../../img/imgsTela2/pessoa6.png";
import finalista7 from "../../img/imgsTela2/pessoa7.jpeg";
import finalista8 from "../../img/imgsTela2/pessoa8.jpeg";
import finalista9 from "../../img/imgsTela2/pessoa9.jpeg";
import finalista10 from "../../img/imgsTela2/pessoa10.jpg";
import finalista11 from "../../img/imgsTela2/pessoa11.jpg";

export default function Tela2(){

    const [videoAberto, setVideoAberto] = useState(false);

    const finalistas = [
        { id: 1, nome: "Aline Pimentel", foto: finalista1 },
        { id: 2, nome: "Amanda Lienthier", foto: finalista2 },
        { id: 3, nome: "Celso Barreto", foto: finalista3 },
        { id: 4, nome: "Eliedson Gama", foto: finalista4 },
        { id: 5, nome: "Filipe Almeida", foto: finalista5 },
        { id: 6, nome: "Hailla Chagas", foto: finalista6 },
        { id: 7, nome: "Leonardo Lins", foto: finalista7 },
        { id: 8, nome: "Manuela Fiais", foto: finalista8 },
        { id: 9, nome: "Rafael Santiago", foto: finalista9 },
        { id: 10, nome: "Romario Andrade", foto: finalista10 },
        { id: 11, nome: "Valmir Lima", foto: finalista11 },
    ];

    const getItensPorPagina = () => {
    if (window.innerWidth <= 441) return 2;
    if (window.innerWidth <= 671) return 3;
    if (window.innerWidth <= 786) return 5;
    return 6;
    };

    const [itensPorPagina, setItensPorPagina] = useState(getItensPorPagina());
    const [inicio, setInicio] = useState(0);

    useEffect(() => {
    const handleResize = () => {
        setItensPorPagina(getItensPorPagina());
        setInicio(0);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
    }, []);

    const proximo = () => {
        if (inicio + itensPorPagina < finalistas.length) {
        setInicio(inicio + 1);
        }
    };

    const anterior = () => {
        if (inicio > 0) {
        setInicio(inicio - 1);
        }
    };

    const finalistasVisiveis = finalistas.slice(inicio, inicio + itensPorPagina);

    return(
        <section className="tela02" id="tela02">

            <div className="tela02__container">

                <div className="tela02__topo">
                   
                    <button className="tela02__nav tela02__nav--left" onClick={anterior} aria-label="Voltar">
                    <IoIosArrowBack />
                    </button>

                    <div className="tela02__finalistas-area">
                        <h3 className="tela02__titulo-topo">Finalistas</h3>

                        <div className="tela02__finalistas">
                            {finalistasVisiveis.map((item) => (
                                <div className="finalista" key={item.id}>
                                <img src={item.foto} alt={item.nome} className="finalista__foto" />
                                <p className="finalista__nome">{item.nome}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <button className="tela02__nav tela02__nav--right" onClick={proximo} aria-label="Avançar">
                        <IoIosArrowForward />
                    </button>

                </div>

                <div className="tela02__linha-brilho" />

                <div className="tela02__card-video">
                    <div className="tela02__video-box">
                        <img src={videoThumb} alt="Vídeo Inovaê Docente 2025" className="tela02__video-thumb" />

                        <button className="tela02__play" aria-label="Reproduzir vídeo" onClick={() => setVideoAberto(true)}>
                        ▶
                        </button>
                    </div>

                    <h2 className="tela02__chamada">
                        Assista ao vídeo do Inovaê Docente 2025 e confira as informações para o pitch 2026.
                    </h2>
                </div>

                <div className="tela02__texto">
                    <p>
                        Finalmente temos os vencedores das 3 Melhores Práticas Inovaê Docente 2025. Após lançamento do edital 34 docentes se inscreveram seus vídeos pitch. Uma banca de avaliadores locais, incluindo os Embaixadores das Tecnologias Educacionais, selecionou 15 docentes para representar suas unidades/regionais.  
                    </p>

                    <p>
                        Por fim, uma banca de avaliação composta por Ana Cristina Luz, Emmanuele Arraz e Leonardo Silveira, selecionou as 3 melhores práticas: 
                    </p>
                </div>

            </div>

            {videoAberto && (
                <div className="video_modal" onClick={() => setVideoAberto(false)}>
                <div
                    className="video_modal__content"
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                    className="video_modal__close"
                    onClick={() => setVideoAberto(false)}
                    aria-label="Fechar vídeo"
                    >
                    ×
                    </button>

                    <div className="video_modal__iframeWrapper">
                    <iframe
                        width="560"
                        height="315"
                        src="https://www.youtube.com/embed/Dqj7kZ9MOg8?si=Zq0959SAOIjzQGs5&autoplay=1"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    />
                    </div>
                </div>
                </div>
            )}

        </section>

    )


}